import TabControl from './TabControl';
import Tab from './Tab';

export default TabControl;
export { TabControl, Tab };
